import { Redirect, useLocalSearchParams, useRouter } from 'expo-router'
import { ContactInterestFlow } from '~/components/interests/ContactInterestFlow'
import ScreenView from '~/components/layout/ScreenView'

export default function UpdateLeadSearchIndex() {
  const { leadId, assetId } = useLocalSearchParams<{
    leadId: string
    assetId?: string
  }>()

  const router = useRouter()

  const handleComplete = () => {
    router.replace({
      pathname: `/leads/[leadId]`,
      params: { leadId },
    })
  }

  if (!assetId) {
    return (
      <Redirect
        href={{
          pathname: `/leads/[leadId]`,
          params: { leadId },
        }}
      />
    )
  }

  return (
    <ScreenView>
      <ContactInterestFlow
        assetId={assetId}
        contactId={leadId}
        onComplete={handleComplete}
        onClose={handleComplete}
      />
    </ScreenView>
  )
}
